define([
    "./attributableModule",
    "./attributableEdition"
], function () {
});